import axios from "axios";

const state = {
  params: {}
};

const getters = {
  params: state => state.params
};

const actions = {};

const mutations = {
  SET_PARAMS(state, params) {
    state.params = params;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
